// components/YouTubeEmbed.jsx
import React from "react";
import "../css/YoutubeEmbed.css"; // add CSS file


const YouTubeEmbed = ({ url, width = "560", height = "315" }) => {
  if (!url) return null;

  const getYouTubeId = (link) => {
    try {
      const urlObj = new URL(link);
      if (urlObj.hostname === "youtu.be") {
        return urlObj.pathname.slice(1);
      }
      return urlObj.searchParams.get("v");
    } catch {
      return link; // assume raw videoId
    }
  };

  const videoId = getYouTubeId(url);

  return (
    <div className="youtube-video">
      <iframe
        width={width}
        height={height}
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default YouTubeEmbed;
